class BocalCalculator {
  constructor() {

    /* =========================
       INPUTS / CONFIGURAÇÕES
    ========================= */
    this.soldaCostado = "";

    this.diametroInternoAbertura = 0;
    this.diametroInternoCasco = 0;

    this.eficienciaJuntaBocal = 0;
    this.eficienciaJuntaCasco = 0;

    this.corrosaoAdmissivelBocal = 0;
    this.corrosaoAdmissivelCasco = 0;

    this.espessuraNominalCasco = 0;
    this.espessuraNominalBocal = 0;

    this.espessuraChapaReforco = 0;
    this.tensaoAdmissivelChapaReforco = 0;
    this.diametroChapaReforco = 0;

    this.fatorCorrecao = 0;

    this.extBocalCostPad = 0;
    this.padCostado = 0;
    this.intBocalCost = 0;

    this.h = 0;


    /* =========================
       DADOS EXTERNOS / PROJETO
    ========================= */
    this.pressaoProjeto = 0;
    this.temperaturaProjeto = 0;

    this.materialCasco = "";
    this.tensaoAdmissivelCasco = 0;

    this.materialSpecification = null;
    this.tensaoAdmissivelBocal = 0;


    /* =========================
       FLANGE / UG-45
    ========================= */
    this.materialFlange = "";
    this.pressureRating = "";
    this.wamp = 0;

    this.nominalDiameterNozzle = "";
    this.externalRadiusNozzle = 0;

    this.ug45 = 0;
    this.thicknessTa = 0;
    this.minThicknessUG45 = 0;


    /* =========================
       RESULTADOS CALCULADOS
    ========================= */
    this.raioInternoBocalCorroido = 0;

    this.espessuraMinimaCasco = 0;
    this.espessuraCorroidaCasco = 0;
   this.validNominalThickness = true;

    this.espessuraMinimaBocal = 0;
    this.espessuraCorroidaBocal = 0;

    this.calculo2RnMaisTnMaisTv = 0;
    this.calculo2dMais2Can = 0;

    this.DL = 0;

    this.calculo2ponto5Tv = 0;
    this.calculo2ponto5TnMaisTe = 0;

    this.TLNP = 0;

    this.razaoSnSv = 0;
    this.menorSnSvSrSv = 0;
    this.razaoSeSv = 0;

    this.A1formula1 = 0;
    this.A1formula2 = 0;
    this.A1 = 0;

    this.A2formula1 = 0;
    this.A2formula2 = 0;
    this.A2 = 0;

    this.areaSoldaExterna = 0;
    this.areaSoldaPadCostado = 0;
    this.areaSoldaInterna = 0;

    this.areaBocalPenetraCasco = 0;
    this.areaChapaReforco = 0;

    this.areaRequerida = 0;
    this.areaTotalReforco = 0;

    this.resultadoRefoço = "";
    this.resultado = "";

    this.cargaTotalSoldas = 0;
    this.cargaLinhaFalha11 = 0;
    this.cargaLinhaFalha22 = 0;
    this.cargaLinhaFalha33 = 0;

    this.tensaoAdmissivelSoldas = 0;

    this.cisalhamentoSoldaBocalPad = 0;
    this.cisalhamentoSoldaPadCasco = 0;

    this.tracaoSoldaTopoPadCasco = 0;
    this.tracaoSoldaTopoCascoBocal = 0;

    this.resistenciaBocal = 0;
    this.resistenciaChapaReforco = 0;

    this.resistenciaLinha11 = 0;
    this.resistenciaLinha22 = 0;
    this.resistenciaLinha33 = 0;

    this.resultadoLinha11 = "";
    this.resultadoLinha22 = "";
    this.resultadoLinha33 = "";

    this.resultadoChapaReforco = "";

    this.alertaErrdimensionalBocal = "";
  }
}

export default BocalCalculator;